import { reactive, computed, triggerRef, watchEffect, ref } from 'vue'

class I18N {
  constructor({local = {}, lang}) {
    this.local     = ref(local);
    this.lang      = ref(lang);
    this.onChanhed = {};
  }
  
  install(app, options) {
    app.config.globalProperties.$static  = (key, basic) => {
      if (this.local.value[key]) {
        return this.local.value[key];
      }
      this.local.value[key] = basic;
      return this.local.value[key];
    };
    app.config.globalProperties.$dynamic = (item, basic, key) => {
      if (item && item.translate && item.translate[this.lang] && key && item.translate[this.lang][key]) {
        return item.translate[this.lang][key]
      }
      return basic;
    };
    app.config.globalProperties.$load    = (local, lang) => {
      this.local.value = Object.assign(this.local.value, local);
      this.lang        = lang;
      Object.keys(this.onChanhed).forEach(x => this.onChanhed[x]())
    };
    
    app.config.globalProperties.$local = () => {
      return this.local
    };
    
    app.config.globalProperties.$lang     = () => {
      return this.lang
    };
    app.config.globalProperties.$watchLangChange = (key, value) => {
      this.onChanhed[key] = value
    };
    
    app.config.globalProperties.$dynamics = () => {
      return this.dynamic
    };
  }
}

export default I18N
